module.exports = __webpack_public_path__ + "static/githyanki_gish-7b1ebb44db0861e5219e0c3a75f03a62.png";